<template>
    <el-container>
        <el-header>
                <el-col>
                    <el-form :inline="true" :model="fromLog" ref="fromLog" class="demo-form-inline">
                        <td-permission :roles="roles" style="float:right;">
                            <div slot="havePermission">
                                <el-form-item :label="$t('common.CURSYS')">
                                    <td-select
                                        v-model="fromLog.sysFlg"
                                        :placeholder="$t('common.PLEASE_SELECT')"
                                        @change="btnClickQuery()"
                                        :options="this.sysAndFlgList"
                                        keys="sSysFlg"
                                        text="sName"
                                        :pageSize="selectPageSize"
                                        :clearable="false"
                                    >
                                    </td-select>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <td-permission :oneOfPermissions="permissionsQuery">
                            <div slot="havePermission">
                                <el-form-item :label="$t('common.NAME')" prop="sQueueName">
                                    <td-input v-model="fromLog.sName"></td-input>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <el-form-item>
                            <td-button type="primary" :loading="loading" @click="btnClickQuery" :permissions="permissionsQuery">{{ $t('common.QUERY') }}</td-button>
                            <td-button type="button" @click="btnAdd" :permissions="permissionsAdd">{{ $t('common.ADD') }} </td-button>
                            <td-button type="button" @click="btnDeleteBatch" :permissions="permissionsDelete">{{ $t('common.DELETE') }} </td-button>
                        </el-form-item>
                    </el-form>
                </el-col>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                ref="listLevelInfo"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                :permissions="permissionsQuery"
                :hasLoading="loading"
                :rowKey="rowKey"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-LevelInfo
                v-if="dialogLevelVisible"
                :isAddData="isAddData"
                :dialogLevelVisible="dialogLevelVisible"
                :editItem="editItem"
                :title="title"
                ref="addOrModifyInfo"
                :sSysFlg="this.fromLog.sysFlg"
                @logLevelDialogClose="logLevelDialogClose"
                @submit="btnClickQuery"
            ></dialog-LevelInfo>
        </el-main>
    </el-container>
</template>

<script>
import dialogLevelInfo from './components/dialogLevelInfo.vue';
import levelApi from './assets/api.js';
export default {
    // 初始化渲染
    components: {
        'dialog-LevelInfo': dialogLevelInfo
    },
    created() {
        if (this.$common.systemInfo.systemId) {
            this.fromLog.sysFlg = this.$common.systemInfo.systemId;
        } else {
            this.fromLog.sysFlg = 'PG';
        }
        let param = {};
        levelApi.getSysList(JSON.stringify(param), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$log.error('sys/getSysList', response.data.statusMessage);
            }
            this.sysList = response.data.content;
            this.sysAndFlgList = [];
            for (let index = 0; index < this.sysList.length; index++) {
                let element = this.sysList[index];
                this.sysAndFlgList.push({ sName: element.sName + '：' + element.sSysFlg, sSysFlg: element.sSysFlg });
            }
        });
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.btnClickQuery(); // 进行页面初始化数据的加载
    },
    // 定义数据
    data() {
        return {
            permissionsQuery: ['type:view'],
            permissionsDelete: ['type:del'],
            permissionsAdd: ['type:add'],
            permissionsEdit: ['type:edit'],
            fromLog: { sQueueName: '', sysFlg: '' },
            editItem: '',
            listMqInfo: [],
            dialogLevelVisible: false,
            dialogRelatedSetVisible: false,
            tableData: [],
            hasIndex: false,
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false,
            sysList: [],
            sysAndFlgList: [],
            roles: ['admin'],
            selectPageSize: 10,
            rowKey: 'sId',
            columns: [
                {
                    prop: 'sCaption',
                    label: 'common.NAME'
                },
                {
                    prop: 'sDescribe',
                    label: 'common.DESCRIPTION'
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '300',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: this.permissionsEdit },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: this.permissionsDelete },
                                    on: {
                                        click: () => {
                                            this.btnDelete(params.row.sId);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.submit();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                sCaption: this.fromLog.sName,
                pageNum: this.currentPage,
                sSysFlg: this.fromLog.sysFlg,
                pageSize: this.pageSize,
                isPage: true
            };
            levelApi.queryOperationLevel(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.loading = false;
                    this.$log.error('logLevelManager/queryOperationLevel', response);
                    return;
                }
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('logLevelManager/queryOperationLevel', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },

        // 添加
        btnAdd() {
            this.title = this.$t('common.ADD') + this.$t('common.OPERATION_LEVEL'); // 标题
            this.isAddData = true;
            this.dialogLevelVisible = true;
        },

        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT') + this.$t('common.OPERATION_LEVEL');
            this.isAddData = false;
            this.dialogLevelVisible = true;
        },
        // 删除接口
        btnDelete(sId) {
            this.$confirm(this.$t('userInfo.DELETE_THIS_OPERATION_LEVEL'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    
                    let param = { sId: sId };
                    levelApi.deleteOperationLevel(param, response => {
                        console.log('response',response)
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('logLevelManager/deleteOperationLevel', response.data.statusMessage);
                            return;
                        }
                        if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                           
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('logLevelManager/deleteOperationLevel', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.btnClickQuery();
                    });
                })
                .catch(() => {});
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        //查询按钮查询
        btnClickQuery() {
            this.currentPage = 1;
            this.btnQuery();
        },
        // 关闭页面
        logLevelDialogClose() {
            this.dialogLevelVisible = false;
        },
        // 批量删除
        btnDeleteBatch() {
            this.$log.info('btnDeleteBatch');
            let params = this.getSelects();
            if (!params.length) {
                this.$message({ showClose: true, message: this.$t('userInfo.SELECT_OPE_LEVEL'), type: 'warning' });
                return;
            }
            this.$confirm(this.$t('userInfo.DELETE_OPERATION_LEVEL'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    levelApi.deleteOperationLevelBatch(JSON.stringify(params), response => {
                        
                        if (response.status !== this.$common.login.RESPONSE_STATUS) {
                            
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('logLevelManager/btnDeleteBatch', response);
                            return;
                        }
                        if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                             
                            this.$log.error('logLevelManager/deleteOperationLevel', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.OPERATION_SUCCESS'), type: 'success' });
                        this.btnClickQuery();
                    });
                })
                .catch(() => {});
        },
        // 获取级别主键
        getSelects() {
            let ids = this.$refs.listLevelInfo.getSelectAllRows();
            let content = [];
            for (let i = 0; i < ids.length; i++) {
                let temValue = ids[i];
                let select = { sId: temValue.sId };
                content.push(select);
            }
            return content;
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
